// extracted by css-extract-rspack-plugin
export default {"ListItemTitle_0":"IssuePullRequestTitle-module__ListItemTitle_0__CBNvC","ListItemTitle_1":"IssuePullRequestTitle-module__ListItemTitle_1__HZYnd"};